import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MoreActionsPanelComponent } from './more-actions-panel.component';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';

@NgModule({
  declarations: [
    MoreActionsPanelComponent
  ],
  imports: [
    CommonModule,
    SvgIconModule
  ],
  exports: [
    MoreActionsPanelComponent
  ]
})
export class MoreActionsPanelModule { }
